export const GAME_MASTER_ROLE = "game master"
export const ADMIN_ROLE = "Admin"
export const SUPER_ADMIN_ROLE = "SuperAdmin"
export const SUPER_USER_ROLE = "SuperUser"
export const USER_ROLE = "User"
export const VIEWER_ROLE = "Viewer"